
// eslint-disable-next-line import/extensions
import '@formatjs/intl-pluralrules/polyfill-force.js';
import '@formatjs/intl-pluralrules/locale-data/en'; // locale-data for en
import '@formatjs/intl-pluralrules/locale-data/de'; // locale-data for de
import '@formatjs/intl-pluralrules/locale-data/pl'; // locale-data for pl
import '@formatjs/intl-pluralrules/locale-data/tr'; // locale-data for tr
import '@formatjs/intl-pluralrules/locale-data/it'; // locale-data for it
import '@formatjs/intl-pluralrules/locale-data/es'; // locale-data for es
import '@formatjs/intl-pluralrules/locale-data/nl'; // locale-data for nl
import '@formatjs/intl-pluralrules/locale-data/fr'; // locale-data for fr

// eslint-disable-next-line import/extensions
import '@formatjs/intl-relativetimeformat/polyfill-force.js';
import '@formatjs/intl-relativetimeformat/locale-data/en';
import '@formatjs/intl-relativetimeformat/locale-data/pl';
import '@formatjs/intl-relativetimeformat/locale-data/de';
import '@formatjs/intl-relativetimeformat/locale-data/tr';
import '@formatjs/intl-relativetimeformat/locale-data/it';
import '@formatjs/intl-relativetimeformat/locale-data/es';
import '@formatjs/intl-relativetimeformat/locale-data/nl';
import '@formatjs/intl-relativetimeformat/locale-data/fr';

// eslint-disable-next-line import/extensions
import '@formatjs/intl-listformat/polyfill-force.js';
import '@formatjs/intl-listformat/locale-data/en';
import '@formatjs/intl-listformat/locale-data/pl';
import '@formatjs/intl-listformat/locale-data/de';
import '@formatjs/intl-listformat/locale-data/tr';
import '@formatjs/intl-listformat/locale-data/it';
import '@formatjs/intl-listformat/locale-data/es';
import '@formatjs/intl-listformat/locale-data/nl';
import '@formatjs/intl-listformat/locale-data/fr';

import 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/pl';
import 'moment/locale/de';
import 'moment/locale/tr';
import 'moment/locale/it';
import 'moment/locale/es';
import 'moment/locale/nl';
import 'moment/locale/fr';

// eslint-disable-next-line import/order
import { crashReporterMiddleware } from './errorhandler';

import axios from 'axios';
import { setupAxiosInterceptors } from './config/axiosConfig';
import tokenManager from './services/tokenManager';

import promise from 'redux-promise-middleware';

import { getLogger, setupRedux } from '@chedri/base';

import { activeFormsMiddleware } from './reducers/activeForms';
import { checkoutMiddleware } from './reducers/checkout';

import { mayUseVideoCall, mayUseAudioCall } from './helpers/webrtccall';

import { initWebApp } from './sagas/appInitializeSaga';
import watchRealtimeEventActions from './sagas/realtimeEventSagas';

import { rootClientReducer } from './reducers';

import { locale as en } from './intl/messages.en';
import { locale as de } from './intl/messages.de';
import { locale as pl } from './intl/messages.pl';
import { locale as tr } from './intl/messages.tr';
import { locale as it } from './intl/messages.it';
import { locale as es } from './intl/messages.es';
import { locale as nl } from './intl/messages.nl';
import { locale as fr } from './intl/messages.fr';
import globals from './globals';

// console.log('Loading configure store');

const logger = getLogger('configure-store');

const { locale } = globals;

export default function configureStore(history) {
  const middlewares = [
    promise,
    crashReporterMiddleware,
    activeFormsMiddleware,
    checkoutMiddleware,
  ];
  if (
    (logger.rootLogger && logger.rootLogger.config.useReduxLogger) ||
    (!logger.rootLogger && logger.config.useReduxLogger)
  ) {
    middlewares.push(customLogger);
  }

  // const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const sagas = [initWebApp, ...watchRealtimeEventActions];
  const reduc = {
    router: (state = { location: history.location }) => state,
    ...rootClientReducer
  };

  const store = setupRedux(middlewares, reduc, sagas, undefined, {
    isMobile: false,
    locale,
    messages: { en, de, pl, tr, it, es, nl, fr },
    http: axios,
    canUseAudioCall: mayUseAudioCall,
    canUseVideoCall: mayUseVideoCall,
    RTCPeerConnection:
      window.RTCPeerConnection ||
      window.mozRTCPeerConnection ||
      window.webkitRTCPeerConnection ||
      window.msRTCPeerConnection,
    mediaDevices: navigator.mediaDevices,
    // Token-based socket authentication
    getSocketToken: () => tokenManager.getAccessToken(),
    socketOptions: {
      withCredentials: false, // Disable cookie-based auth
      auth: (cb) => {
        // Provide token dynamically via auth handshake (socket.io v3+)
        const token = tokenManager.getAccessToken();
        cb({ token });
      },
      // Token is passed via auth handshake only (not query string)
    },
  });

  // Setup axios interceptors for token-based authentication
  setupAxiosInterceptors(store);

  return store;
}

// Custom, lightweight replacement for createLogger({ collapsed: true })
const customLogger = (store) => (next) => (action) => {
  console.groupCollapsed(`Action: ${action.type}`);
  console.log('%c prev state', 'color: #9E9E9E; font-weight: bold;', store.getState());
  console.log('%c action', 'color: #03A9F4; font-weight: bold;', action);

  const result = next(action);

  console.log('%c next state', 'color: #4CAF50; font-weight: bold;', store.getState());
  console.groupEnd();

  return result;
};
